<template>
  <div class="sidenav-wrapper">
    <div
      class="sidenav-container"
      :class="{ ['sidenav-container-' + componentStyle.header]: isHeaderInfo }"
    >
      <h1>
        <div class="navbar-brand" @click="goToHomePage">
          <img class="img-fluid image_base64" src="../assets/img/logo.png" alt="Logo" width="100" />
        </div>
      </h1>
      <div :class="['main-content', { 'main-content-info': isHeaderInfo }]">
        <div class="main-buttons-container">
          <div class="large-header-menu" v-if="componentStyle.header === 'large'">
            <h3 class="subtitle">Menu</h3>
            <a href="#" @click.prevent="setCategory('trends')">
              <i class="fo-icon-home"></i>
              {{ $t('menu.home') }}
            </a>
            <!--<a href="#" @click.prevent="setCategory('trends')">
              <i class="fo-icon-most-watched"></i>{{ categories.trends }}
            </a>-->
            <a href="#" @click.prevent="setCategory('popular')">
              <i class="fo-icon-popular"></i>
              {{ $t('menu.popular') }}
            </a>
            <a href="#" @click.prevent="setCategory('all')">
              <i class="fo-icon-all"></i>
              {{ $t('menu.allVideos') }}
            </a>
          </div>
          <div v-else-if="isHeaderInfo" class="info-header-menu">
            <div
              class=" search-input-container form-group"
              :class="[
                { 'full-width': isFullWidth, 'side-nav': isSideNav },
                componentStyle.searchInput,
                componentStyle.header + '-header',
              ]"
            >
              <search-bar
                :in-submit="search"
                :placeholder="$t('buttons.search')"
                :title="title"
                :input="title"
                v-model="title"
              ></search-bar>
            </div>
            <item-list></item-list>
          </div>
          <div v-else>
            <button
              class="btn btn-block"
              :class="[currentCategory === 'trends' ? hasOptionsTv ? 'btn-primary-tv': 'btn-primary' : hasOptionsTv ? 'btn-secondary-tv' :'btn-outline-primary',
              { 'tv-options': hasOptionsTv}
              ]"
              @click="setCategory('trends')"
            >
              {{ $t('menu.trends') }}
            </button>
            <button
              class="btn btn-block"
              :class="[currentCategory === 'popular' ? hasOptionsTv ? 'btn-primary-tv':'btn-primary' : hasOptionsTv ? 'btn-secondary-tv' :'btn-outline-primary',
               { 'tv-options': hasOptionsTv}
              ]"
              v-on:click="setCategory('popular')"
            >
              {{ $t('menu.popular') }}
            </button>
            <button
              class="btn btn-block"
              :class="[currentCategory === 'all' ? hasOptionsTv ? 'btn-primary-tv':'btn-primary' : hasOptionsTv ? 'btn-secondary-tv' : 'btn-outline-primary',
               { 'tv-options': hasOptionsTv}
              ]"
              v-on:click="setCategory('all')"
            >
              {{ $t('menu.all') }}
            </button>
          </div>
        </div>
        <div
          v-if="!isHeaderInfo"
          class="main-menu-container"
          :class="[componentStyle.header + '-header',{'tv-options': hasOptionsTv}]"

        >
          <h3 class="subtitle" v-if="componentStyle.header === 'large'">Thèmes</h3>
          <button
            v-for="(item, index) in items"
            @click="itemClicked(item.id)"
            :class="['btn btn-block btn-link text-left', { selected: item.id === +currentTheme },{'tv-options-theme': hasOptionsTv}]"
            :key="index"
            v-show="item.title"
          >
            {{ item.title }}
          </button>
        </div>
      </div>
      <div class="footer-container">
        <b>© {{ clientName }} {{ currentYear }}</b>
        <p>
          {{ $t('labels.powered_by') }}
          <a href="https://www.empreinte.com/" target="_blank">empreinte.com</a>
        </p>
        <p v-if="hasOptionsTv" class="contact-text"  data-toggle="modal" data-target="#modal-contact" >
          {{ $t('labels.contact') }}
        </p>




      </div>
    </div>





  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import SearchBar from '~/node_modules/search-bar/src/components/Component.vue';

import { categories } from '~/static/constants.js';
import Mixin from '@/mixins/Mixin';
import ItemList from './ItemsList';

export default {
  name: 'SideNav',
  mixins: [Mixin],
  data() {
    return {
      categories,
      title: '',
    };
  },
  watch: {
    keyword(newVal) {
      this.title = newVal;
    },
  },
  components: {
    SearchBar,
    ItemList,
  },
  computed: {
    ...mapGetters({
      currentCategory: 'videos/getCurrentCategory',
      currentTheme: 'videos/getCurrentTheme',
      items: 'themes/getAllThemes',
      componentStyle: 'layout/getComponentStyle',
      isFullWidth: 'layout/isFullWidth',
      isSideNav: 'layout/isSideNav',
      keyword: 'videos/getKeyword',
      isHeaderInfo: 'layout/isHeaderInfo',
        hasOptionsTv: 'layout/hasOptionsTv',

    }),
    currentYear() {
      return new Date().getFullYear();
    },
    clientName() {
      return process.env.CLIENT_NAME;
    },
  },
  methods: {
    ...mapActions('videos', ['setCurrentCategory', 'setKeyword','paginateVideos']),
    setCategory(category) {
      this.setCurrentCategory(category);
      this.$router.push({ name: 'home', params: { category } });
        if(!this.isHeaderInfo) {
            this.paginateVideos()
        }
        this.initCarousel()
    },
    async search(keyword) {
        this.title = keyword;
      await this.setKeyword(keyword);
      this.$router.push({ name: 'home', params: { category: 'all' } });
      if (keyword !== '') {
        this.$router.push({ query: { q: keyword } });
      }
      await  this.initCarousel()
    },
    getSearchWord() {
      const query = this.$route.query.q;
      if (query) {
        this.setKeyword(query);
        this.title = query;
      }
    },
    itemToggled(index) {
      document.querySelectorAll('.items-children-' + index).forEach(child => {
        child.classList.toggle('hidden-items-child');
      });
      document.querySelector('.toggle-down').classList.toggle('hidden-items-child');
      document.querySelector('.toggle-up').classList.toggle('show-items-child');
    },
  },
  mounted() {
    this.getSearchWord();
  },
};
</script>

<style scoped lang="scss">
@import '../assets/scss/_variables.scss';
@import 'src/assets/scss/logo';

%search-input-shared {
  .search-input-container {
    flex: 1 0 0;
    &.full-width {
      padding: 1rem 16px 0 4rem;
    }
    &.side-nav {
      padding: 1rem 7rem 0 0;
      position: relative;
      .btnLive {
        position: absolute;
        right: 0;
        top: 0;
        margin: 1rem 0 0;
        font-weight: 500;
        color: var(--primary-color);
        svg path {
          fill: var(--primary-color);
        }
      }
    }
    .search-bar-container {
      --search-bar-input-width: 99%;
      --search-bar-input-height: 2.5em;
      --search-bar-input-border: none;
      --search-bar-input-radius: none;
      --search-bar-input-bg: transparent;
      --search-bar-btn-border: none;
      --search-bar-btn-bg: transparent;
      --search-bar-input-border-top: none;
      --search-bar-input-border-right: none;
      --search-bar-input-border-left: none;
      --search-bar-btn-radius: 0;
      --search-bar-btn-border-top: none;
      --search-bar-btn-border-right: none;
      --search-bar-btn-border-left: none;
      --search-bar-btn-float: left;
      --search-bar-input-text-size: 1rem;
      --search-bar-placeholder-color: #555555;
      --search-bar-input-text-color: #333;
      --search-bar-input-text-padding: 0 0 0 0.5em;
    }

    .search-bar {
      --search-bar-input-text-width: 95%;
      --search-bar-input-placeholder-color: #8e8e8e;
    }

    .icon {
      --search-bar-icon-width: 1em;
      --search-bar-icon-height: 1.5em;
      --search-bar-icon-color: #8e8e8e;
    }
  }
}
.sidenav-wrapper {
  height: 100vh;
  overflow: auto;
  position: sticky;
  top: 0;
  margin: 0 -15px;
  padding: 0 15px;
  &.navbar-fixed {
    position: fixed;
  }
  .sidenav-container {
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 2em 0 0;
    min-height: 100%;
    align-items: center;
    &.sidenav-container-info {
      position: absolute;
      left: 0;
      overflow: auto;
      width: 100%;
    }
    .main-content {
      flex-grow: 1;
      min-height: 50vh;
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      width: 260px;
      max-width: 100%;
      &.main-content-info {
        flex-direction: row;
      }
      a {
        width: 120px;
        display: inline-block;
      }
      .btn:not(.btn-link):hover {
        color: #ffffff !important;
      }
      .main-buttons-container {
        margin-bottom: 1em;
        /deep/ {
          @extend %search-input-shared;
        }
        .icon {
          width: 1em;
          height: 1.5em;
          color: #8e8e8e;
          float: left;
        }
        .large-header-menu {
          font-size: 1.2em;
          text-align: left;
          padding-left: 1rem;
          color: var(--primary-color);
          .subtitle {
            font-size: 1em;
            margin-bottom: 1em;
          }
          a {
            color: var(--primary-color);
            line-height: 3em;
            font-size: 0.8em;
            text-decoration: none !important;
            width: auto;
            display: block;
            &:hover {
              color: var(--secondary-color);
            }
            i {
              margin-right: 0.5rem;
              font-size: 1.2em;
              color: var(--secondary-color);
              width: 25px;
              display: inline-block;
              text-align: center;
            }
          }
        }
        .info-header-menu {
          text-align: left;
          /*padding: 0 1rem;*/
          padding:  1rem;
          /*color: var(--primary-color);*/
          .info-main-menu-container {
            margin: 1em 0;
            &.info-header {
              /*color: var(--primary-color);*/
              font-size: 1.2em;
              text-align: left;
              .info-subtitle {
                font-size: 0.9em;
                margin-bottom: 1em;
                cursor: pointer;
                .toggle-child {
                  display: flex;
                  flex-direction: row;
                  align-items: center;
                  .toggle-down,
                  .toggle-up {
                    padding-left: 5px;
                    width: 1.1em;
                  }
                }
                button {
                  font-size: 0.8em;
                  &:not(.btn-link):hover,
                  &:focus {
                    text-decoration: none;
                    color: var(--secondary-color) !important;
                    box-shadow: none;
                  }
                  &.selected {
                    color: var(--secondary-color) !important;
                    box-shadow: none;
                  }
                }
              }
            }
          }
        }
        .tv-options{
          border-radius: 10px;
          &.btn-primary-tv{
            color: var(--primary-color)!important;
            border-color: var(--primary-color) !important;
            box-shadow: none !important;
            &:hover{
              color: white!important;
              border-color: var(--primary-color) !important;
              background-color: var(--primary-color) !important;
              box-shadow: none !important;
            }
          }
          &.btn-secondary-tv{
            color: var(--secondary-color)!important;
            border-color: var(--secondary-color) !important;
            box-shadow: none !important;
            &:hover{
              color: white!important;
              border-color: var(--secondary-color) !important;
              background-color: var(--secondary-color) !important;
              box-shadow: none !important;
            }
          }
        }
      }
      .main-menu-container {
        margin: 1em 0;
        &.large-header,
        &.info-header {
          color: var(--primary-color);
          font-size: 1.2em;
          text-align: left;
          padding-left: 1rem;
          .subtitle {
            font-size: 1em;
            margin-bottom: 1em;
          }
          button {
            font-size: 0.8em;
            &:hover,
            &:focus {
              text-decoration: none;
              color: var(--secondary-color);
            }
            &.selected {
              color: var(--secondary-color);
            }
          }
        }
        &.tv-options {
          button {
            font-size: 1em;
            color: #585858;
            width: auto !important;
            border-bottom-left-radius: 0!important;
            border-bottom-right-radius: 0!important;
            padding: .375rem 0 !important;
            &:hover,
            &:focus,
            &.selected  {
              text-decoration: none;
              box-shadow: none !important;
              font-weight: bold;
              border-bottom:1px solid var(--secondary-color);
            }
          }
        }
      }
    }
    .footer-container {
      font-size: 0.8em;
      color: #585858;
      .contact-text{
        cursor: pointer;
        font-size: 1.5em;
        color: var(--secondary-color);
      }
    }
  }
}
.hidden-items-child,
.hidden-toggle-up {
  display: none;
}
.show-items-child {
  display: block;
}
  .img-fluid{
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/SideNav.vue